import RewardIcon from '../../../../Icons/Reward'
import AwardsBGIcon from '../../../../Icons/AwardsBGSmall'
import {
  Wrapper,
  Award,
  MedalWrapper,
  Main,
  Year,
  Name,
  Points,
  Footer,
  MedalType,
  Trophy,
} from './_styles'
import { useDragToScroll } from 'utils/hooks/useDragToScroll'

const getRewardNameByType = (rewards, type) => {
  const reward = (rewards || []).find(v => v?.rewardType?.masterName === type)
  return reward?.shortName
}

const AwardsItem = ({ award }) => {
  const year = award?.year
  const name = award?.award?.masterNameShort
  const points =
    award?.maxScore !== award?.minScore
      ? `${award?.minScore} - ${award?.maxScore}`
      : award?.maxScore
  const medal = getRewardNameByType(award?.rewards, 'Medal')
  const trophy = getRewardNameByType(award?.rewards, 'Trophy')

  return (
    <Award>
      <AwardsBGIcon />
      <MedalWrapper>
        <RewardIcon />
      </MedalWrapper>

      <Main>
        <Year>{year}</Year>
        <Name>{name} </Name>
        <Points>{points}</Points>
      </Main>
      <Footer>
        <MedalType>
          {medal}
          {medal && trophy && ','}
        </MedalType>
        <Trophy>{trophy}</Trophy>
      </Footer>
    </Award>
  )
}

const AwardsList = ({ awards }) => {
  const containerProps = useDragToScroll()

  return (
    <Wrapper {...containerProps}>
      {awards.map(award => (
        <AwardsItem key={award.id} award={award} />
      ))}
    </Wrapper>
  )
}

export default AwardsList
